import {Component, Input, OnInit} from "@angular/core";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {QualityGateService} from "../../../../../api/services/quality-gate.service";
import {MessageService} from "primeng/api";
import {QualityGateFilter} from "../../../../../api/models/quality-gate-filter";
import {PlanLinkageEntry} from "../../../../../api/models/plan-linkage-entry";
import {ViewPlanLinkageComponent} from "../../modals/view-plan-linkage/view-plan-linkage.component";

@Component({
  selector: 'app-plan-linkage-unprocessed',
  templateUrl: './plan-linkage-unprocessed.component.html',
  styleUrl: './plan-linkage-unprocessed.component.css',
  standalone: false
})
export class PlanLinkageUnprocessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = {pageSize: 10, pageNumber: 1, totalCount: 0};
  // unprocessedFlags: [] = [];
  selectedTag: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  unprocessedPlanLinkageEntries: PlanLinkageEntry[] = [];
  @Input() selectedTab!: number;
  private matchUnMatch: string = '';

  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {
  }

  ngOnInit(): void {
    this.matchUnMatch = this.selectedTab === 0 ? "match" : "unmatch";
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getUnprocessedPlanLinkage();
  }

  onSearch() {
    // Trim string search fields before building params
    this.issuerName = this.issuerName?.trim() || undefined;
    this.insiderName = this.insiderName?.trim() || undefined;

    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedPlanLinkage();
  }

  getUnprocessedPlanLinkage() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "UNPROCESSED",
      qualityGateType: "PlanLinkage",
      issuerName: this.issuerName ? this.issuerName : undefined,
      insiderName: this.insiderName ? this.insiderName : undefined,
      filingId: this.filingId,
      matchOrUnMatch: this.matchUnMatch
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.unprocessedPlanLinkageEntries =
          value.planLinkageEntries ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedPlanLinkageEntries?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }

  openPlanLinkageModal(share: any) {
    const selectedData = share;
    this.ref = this.dialogService.open(ViewPlanLinkageComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: {width: "60vw"},
      contentStyle: {overflow: "auto"},
      header: "View Plan Linkage",
      data: selectedData,
    });
    this.ref.onClose.subscribe((refresh) => {
      if (refresh) {
        this.getUnprocessedPlanLinkage();
      }
    });
  }
}
